/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Next_Event_TooltipInputs */

const en_timing_sync_next_event_tooltip = /** @type {(inputs: Timing_Sync_Next_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The next event to be shown on screen`)
};

const fr_timing_sync_next_event_tooltip = /** @type {(inputs: Timing_Sync_Next_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le prochain evenement a afficher a l'ecran`)
};

const de_timing_sync_next_event_tooltip = /** @type {(inputs: Timing_Sync_Next_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das nächste Ereignis, das auf dem Bildschirm angezeigt wird`)
};

const it_timing_sync_next_event_tooltip = /** @type {(inputs: Timing_Sync_Next_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il prossimo evento da mostrare sullo schermo`)
};

const ru_timing_sync_next_event_tooltip = /** @type {(inputs: Timing_Sync_Next_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующее событие будет показано на экране.`)
};

const es_timing_sync_next_event_tooltip = /** @type {(inputs: Timing_Sync_Next_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El próximo evento que se mostrará en pantalla`)
};

const zh_cn2_timing_sync_next_event_tooltip = /** @type {(inputs: Timing_Sync_Next_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`屏幕上即将显示的下一个事件`)
};

const ja_timing_sync_next_event_tooltip = /** @type {(inputs: Timing_Sync_Next_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面に表示される次のイベント`)
};

const hi_timing_sync_next_event_tooltip = /** @type {(inputs: Timing_Sync_Next_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्क्रीन पर दिखाई जाने वाली अगली घटना`)
};

const pt_pt2_timing_sync_next_event_tooltip = /** @type {(inputs: Timing_Sync_Next_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O próximo evento a ser exibido na tela`)
};

/**
* | output |
* | --- |
* | "The next event to be shown on screen" |
*
* @param {Timing_Sync_Next_Event_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_next_event_tooltip = /** @type {((inputs?: Timing_Sync_Next_Event_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Next_Event_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_next_event_tooltip(inputs)
	if (locale === "de") return de_timing_sync_next_event_tooltip(inputs)
	if (locale === "it") return it_timing_sync_next_event_tooltip(inputs)
	if (locale === "ru") return ru_timing_sync_next_event_tooltip(inputs)
	if (locale === "es") return es_timing_sync_next_event_tooltip(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_next_event_tooltip(inputs)
	if (locale === "ja") return ja_timing_sync_next_event_tooltip(inputs)
	if (locale === "hi") return hi_timing_sync_next_event_tooltip(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_next_event_tooltip(inputs)
	return en_timing_sync_next_event_tooltip(inputs)
});